import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import Sidebar from "../../components/sidebar/sidebar";
import "./employers.css";
import Topbar from "../../components/topbar/topbar";
import { columns } from "./columns.jsx";
import AddEmployer from "../../components/employers/addEmployer/addEmployer";
import MUIDataTable from "mui-datatables";
import Fontawesome from "../../components/fontawesome/fontawesome";
import { Prefix } from "../../services/prefix";
import { useFetch } from "../../components/hooks/useFetch";
import Loading from "../../components/loader/loading";
import api from "../../services/api";
import Swal from "sweetalert2";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import CustomSearchRender from "../../components/customSearchRender/CustomSearchRender";
import CustomFooter from "../../components/CustomFooter/CustomFooter";
import { Card, Row, Col, Table } from "react-bootstrap";
import { maskTel, maskTelFixo, maskRG, maskCpfCnpj } from "../../services/mask";
import {ListEmployeeTypes} from '../../components/employers/listEmployeeTypes';
import { MuiThemeProvider } from "@material-ui/core/styles";
import { mutate as GlobalMutate } from "swr";
import { GetMuiTheme } from "../../components/muiTheme/muiTheme";
import {
  CardSt,
  CardHeaderSt,
  IconTitleSt,
  TitleSt,
  TextTitleSt,
  SmallTitleSt,
} from "../../style/globalStyle";

const EquipamentsBrands = () => {
  const [loader, setLoader] = useState();
  const [data, setData] = useState();
  const [pagina, setPagina] = useState(0);
  const [perPage, setPerPage] = useState(15);
  const [search, setSearch] = useState("");
  const [orderBy, setOrderBy] = useState("id");
  const [order, setOrder] = useState("desc");

  let pageExact = pagina + parseInt(1);

  const employersList = useFetch(
    Prefix.replace(/[\\"]/g, "") +
      "/employees?per_page=" +
      perPage +
      "&page=" +
      pageExact +
      "&search=" +
      search +
      "&order_by=" +
      orderBy +
      "&order=" +
      order
  );

  const dataList = employersList.data?.models;

  const options = {
    filterType: "dropdown",
    draggableColumns: {
      enabled: true,
    },
    sortOrder: {
      name: orderBy,
      direction: order,
    },
    filter: false,
    serverSide: true,
    onTableChange: (action, tableState) => {
      setOrderBy(
        !tableState.sortOrder.name ? orderBy : tableState.sortOrder.name
      );
      setOrder(
        !tableState.sortOrder.direction ? order : tableState.sortOrder.direction
      );
      setPagina(tableState.page);
      setPerPage(tableState.rowsPerPage);
    },
    onSearchChange: (searchText) => {
      setSearch(!searchText ? "" : searchText);
    },
    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      return (
        <CustomSearchRender
          placeholderSearch="Pesquisar Colaborador(a)"
          searchText={searchText}
          onSearch={handleSearch}
          onHide={hideSearch}
          options={options}
        />
      );
    },
    filter: false,
    page: pagina,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    rowsPerPage: perPage,
    rowsPerPageOptions: [15, 30, 100],
    isRowExpandable: (dataIndex, expandedRows) => {
      //if (dataIndex === 3 || dataIndex === 4) return false; Desativa a 3º e 4º linha
      if (
        expandedRows.data.length > 4 &&
        expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
      )
        return false;
      return true;
    },
    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <Row>
              <Col className="text-center">
                <h4>Dados Pessoais</h4>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>CPF:</th>
                      <th>RG:</th>
                      <th>Endereço:</th>
                      <th>Nº:</th>
                      <th>Bairro:</th>
                      <th>Cidade:</th>
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {" "}
                        {!rowData[8]
                          ? "Não informado"
                          : maskCpfCnpj(rowData[8])}
                      </td>
                      <td>
                        {" "}
                        {!rowData[9] ? "Não informado" : maskRG(rowData[9])}
                      </td>
                      <td> {!rowData[10] ? "Não informado" : rowData[10]}</td>
                      <td> {!rowData[11] ? "Não informado" : rowData[11]}</td>
                      <td> {!rowData[12] ? "Não informado" : rowData[12]}</td>
                      <td> {!rowData[13] ? "Não informado" : rowData[13]}</td>
                    
                    </tr>
                  </tbody>
                </Table>
                <h4>Dados Funcionais e Contato</h4>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Tipo:</th>
                      <th>Email:</th>
                      <th>Celular:</th>
                      <th>Telefone:</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {" "}
                        {!rowData[15]
                          ? "Não informado"
                          : ListEmployeeTypes
                              .filter((filtro) => filtro.value == rowData[15])
                              .map((map) => {
                                return map.label;
                              })}
                      </td>
                      <td> {!rowData[5] ? "Não informado" : rowData[5]}</td>
                      <td>
                        {" "}
                        {!rowData[14] ? "Não informado" : maskTel(rowData[14])}
                      </td>
                      <td>
                        {" "}
                        {!rowData[14]
                          ? "Não informado"
                          : maskTelFixo(rowData[4])}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </TableCell>
        </TableRow>
      );
    },
    onRowsDelete: (rowsDeleted, newData) => {
      /*copiar daqui*/
      setData(newData);
      HandleDelete(rowsDeleted.data);
    },
    searchOpen: true,

    textLabels: {
      body: {
        noMatch: "Desculpe, não encontramos colaboradores!",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: "Avançar",
        previous: "Voltar",
        rowsPerPage: "Linhas por página:",
        displayRows: "de",
      },

      toolbar: {
        search: "Pesquisar",
        downloadCsv: "Baixar CSV",
        print: "Imprimir",
        viewColumns: "Ver Colunas",
        filterTable: "Filtrar tabela",
      },
      filter: {
        all: "Tudo",
        title: "FILTROS",
        reset: "RESETAR",
      },
      viewColumns: {
        title: "Exibir colunas",
        titleAria: "Exibir/Ocultar colunas da tabela",
      },
      selectedRows: {
        text: "Coluna(s) selecionada(s)",
        delete: "Excluir",
        deleteAria: "Excluir linhas selecionadas",
      },
    },
    customFooter: (
      count,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage,
      textLabels
    ) => {
      let numberPages = dataList?.last_page;
      let rowsPerPageOptions = [15, 30, 100];
      return (
        <CustomFooter
          page={page}
          rowsPerPage={rowsPerPage}
          changeRowsPerPage={changeRowsPerPage}
          changePage={changePage}
          numberPages={numberPages}
          rowsPerPageOptions={rowsPerPageOptions}
        />
      );
    },
  };

  function HandleDelete(e) {
    setLoader(<Loading />);
    let idArr = [];
    e.map((del) => {
      idArr.push(
        dataList?.data.filter((filtro, index) => index == del.index)[0].id
      );
    });

    idArr.map((idDel) =>
      api
        .delete(Prefix.replace(/[\\"]/g, "") + "/employees/" + idDel)
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "Uow!",
            text: response.data.message,
            confirmButtonText: "Fechar",
          });
          setLoader();
          GlobalMutate(
            Prefix.replace(/[\\"]/g, "") +
              "/employees?per_page=" +
              perPage +
              "&page=" +
              pageExact +
              "&search=" +
              search +
              "&order_by=" +
              orderBy +
              "&order=" +
              order
          );
          employersList.mutate();
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message,
            confirmButtonText: "Tentar novamente",
          });
          setLoader();
        })
    );
  }

  return (
    <div className="wrapper d-flex align-items-stretch">
      <Sidebar />
      <div id="content">
        <Topbar />
        <div className="content_all">
          {loader}
          <CardSt>
            <CardHeaderSt className="d-flex justify-content-between">
              <TitleSt>
                <IconTitleSt
                  style={{ width: "36px" }}
                  src="../../../media/icons-pages/users-page.svg"
                />
                <TextTitleSt>
                  Colaboradores{" "}
                  <SmallTitleSt>Gestão de Colaboradores</SmallTitleSt>
                </TextTitleSt>
              </TitleSt>
            </CardHeaderSt>
            <CardSt.Body as="div">
              <CardSt.Text as="div">
                <MuiThemeProvider theme={GetMuiTheme()}>
                  <MUIDataTable
                    data={dataList?.data}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </CardSt.Text>
            </CardSt.Body>
          </CardSt>
          <AddEmployer
            titleLabel="Cadastro de Colaborador(a)"
            buttonLabel="Adicionar"
            iconClass="fas fa-plus-circle"
            pageExact={pageExact}
            perPage={perPage}
            search={search}
            orderBy={orderBy}
            order={order}
          />
        </div>
      </div>
    </div>
  );
};

export default EquipamentsBrands;
